/**
 * Figma — "Starting intake session" overlay shown while the Gate-0 chat
 * bootstraps. Mirrors the Gate 2 "Executing Custom Test Case…" loader.
 */
import { Box, Dialog, LinearProgress, Typography } from "@mui/material";
import LogoIcon from "../../asserts/logo/Icon.svg";

export default function IntakeStartingSessionDialog({ open }) {
  return (
    <Dialog
      open={open}
      maxWidth={false}
      PaperProps={{
        sx: {
          m: 2,
          width: "100%",
          maxWidth: 480,
          borderRadius: "16px",
          overflow: "visible",
          bgcolor: "transparent",
          boxShadow: "none",
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            bgcolor: "rgba(255, 255, 255, 0.72)",
            backdropFilter: "blur(10px)",
          },
        },
      }}
    >
      <Box
        sx={{
          p: "1px",
          borderRadius: "16px",
          background: "linear-gradient(135deg, #005BF0 0%, #A855F7 45%, #005BF0 100%)",
        }}
      >
        <Box
          sx={{
            bgcolor: "#FFFFFF",
            borderRadius: "15px",
            px: 3,
            pt: 3.5,
            pb: 3,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2.5 }}>
            <Box
              sx={{
                position: "relative",
                width: 88,
                height: 88,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  borderRadius: "50%",
                  border: "2px dashed #BFDBFE",
                  animation: "intakeStartingShieldSpin 14s linear infinite",
                  "@keyframes intakeStartingShieldSpin": {
                    from: { transform: "rotate(0deg)" },
                    to: { transform: "rotate(360deg)" },
                  },
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  inset: 10,
                  borderRadius: "50%",
                  border: "1px dashed #E9D5FF",
                  animation: "intakeStartingShieldSpinRev 20s linear infinite",
                  "@keyframes intakeStartingShieldSpinRev": {
                    from: { transform: "rotate(360deg)" },
                    to: { transform: "rotate(0deg)" },
                  },
                }}
              />
              <Box
                component="img"
                src={LogoIcon}
                alt="ValidAIte"
                sx={{ width: 38, height: "auto", display: "block", objectFit: "contain", zIndex: 1 }}
              />
            </Box>

            <Typography
              sx={{
                fontFamily: "Lato, sans-serif",
                fontSize: 18,
                fontWeight: 700,
                lineHeight: "26px",
                color: "#0F172A",
                textAlign: "center",
                mb: 1.5,
              }}
            >
              Starting intake session
            </Typography>

            <Typography
              sx={{
                fontFamily: "Lato, sans-serif",
                fontSize: 14,
                fontWeight: 400,
                lineHeight: "22px",
                color: "#64748B",
                textAlign: "center",
              }}
            >
              Loading framework and Gate 0 data...
            </Typography>
          </Box>

          <LinearProgress
            sx={{
              height: 6,
              borderRadius: 3,
              bgcolor: "#E2E8F0",
              "& .MuiLinearProgress-bar": {
                borderRadius: 3,
                backgroundImage: "linear-gradient(90deg, #005BF0 0%, #7F2CE8 55%, #C026D3 100%)",
              },
            }}
          />
        </Box>
      </Box>
    </Dialog>
  );
}
